import { defaultTexts } from "./texts.js";
import { englishTexts } from "./texts.en.js";
import { frenchTexts } from "./texts.fr.js";
const byLanguage = {
    de: defaultTexts,
    en: englishTexts,
    fr: frenchTexts,
};
/**
 * The library's own texts for a language tag ("en", "en-GB", "fr-FR" …), German
 * for anything else. An i18n app passes the active language and overrides the
 * few keys it words differently:
 *
 *   <TextsProvider texts={{ ...textsFor(i18n.language), logout: t("signOut") }}>
 */
export function textsFor(language) {
    const base = (language ?? "").toLowerCase().split(/[-_]/)[0];
    return byLanguage[base] ?? defaultTexts;
}
